export enum CrmAccount {
  Internal = "001",
}
